/**
 * 其知网 收藏管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>收藏管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.zlmc" style="width:140px" placeholder="输入专利名称"></el-input>
        <el-input size="small" v-model="formInline.zlid" style="width:140px" placeholder="输入专利号"></el-input>
        <el-input size="small" v-model="formInline.mobile" style="width:140px" placeholder="输入联系方式"></el-input>
        类型：
        <el-select size="small" v-model="formInline.type" style="width:140px" placeholder="请选择">
          <el-option v-for="type in patentType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
        授权状态：
        <el-select size="small" v-model="formInline.auth" style="width:140px" placeholder="请选择">
          <el-option v-for="type in patentAuth" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
        出售方式：
        <el-select size="small" v-model="formInline.sale_type" style="width:140px" placeholder="请选择">
          <el-option v-for="type in saleType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="" title="将导出所有勾选的数据" @click="exportCheck">导出</el-button>
        <el-button size="small" type="primary" icon="" title="将导出所有满足条件的数据" @click="exportAll">导出全部</el-button>
      </el-form-item>

    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="application_nb" align="center" label="专利号" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" align="center" label="专利类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="price_name" align="center" label="出售价格" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pc_mobile" align="center" label="联系方式" width="120px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="category_name" align="center" label="所属行业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sale_type" align="center" label="出售方式" :formatter="saleFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="auth_status" align="center" label="授权状态" :formatter="authFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="收藏时间" width="150px" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { webMarketSaleFavList, webUrl, webExportCheckCollection, webExportAllCollection } from '../../api/webMG'
import Pagination from '../../components/Pagination'
// import Upload from '../../components/upload.vue'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

import { checkLogin } from '../../utils/util'
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {

      // 视频上传开始
      fileList: [],//文件列
      showProgress: false,//进度条的显示
      dataObj: {}, //存签名信息
      progress: 0, //进度条数据
      // 视频上传结束

      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, // 控制编辑页面显示与隐藏
      verifyFormVisible: false,// 控制审核页面显示与隐藏
      addFormVisible: false,// 控制添加页面显示与隐藏
      cateFormVisible: false,// 控制行业选择页面显示与隐藏
      excelFormVisible: false,// 控制Excel表格上传页面显示与隐藏
      verifyCheckVisible: false,// 控制选中审核页面显示与隐藏
      cateCheckVisible: false,// 控制选中行业设置页面显示与隐藏
      uploadUrl: '',
      title: '添加分类',
      excelUrl: '',
      multipleSelection: [],
      patentTypes: [
        { key: '外观设计', value: '外观设计' },
        { key: '实用新型', value: '实用新型' },
        { key: '发明专利', value: '发明专利' },
      ],
      patentType: [
        { key: '全部', value: 0 },
        { key: '外观设计', value: '外观设计' },
        { key: '实用新型', value: '实用新型' },
        { key: '发明专利', value: '发明专利' },
      ],
      patentStatus: [
        { key: '全部', value: 0 },
        { key: '正常', value: 1 },
        { key: '异常', value: 2 },
        { key: '已下架', value: 3 },
        { key: '待审核', value: 4 },
      ],
      patentAuth: [
        { key: '全部', value: 0 },
        { key: '已下证', value: 1 },
        { key: '未下证', value: 2 },
      ],
      saleType: [
        { key: '全部', value: 0 },
        { key: '许可', value: 1 },
        { key: '转让', value: 2 },
      ],
      cateList: [],
      infoForm: {
        id: '',
        title: '',
        type: '',
        icon: '',
        sort: '',
        status: '',
        note: '',
        application_number: '',
       
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/market/readExcelLarge',
      // 审核数据model
      verifyForm: {
        id: '',
        title: '',
        type: '',
        sort: '',
        status: '',
        note: '',
        application_number: '',
      },
      // 批量审核数据model
      verifyCheck: {
        ids: '',
        status: '',
        note: '',
      },
      // 批量行业设置数据model
      cateCheck: {
        ids: '',
        category_id: '',
        category_name: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        zlmc: '',
        zlid: '',
        mobile: '',
        type: '',
        auth: '',
        sale_type: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
    }
  },
  // 注册组件
  components: {
    Pagination, 
    // Upload
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

      // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/market/readExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取收藏列表
    getdata(parameter) {
        console.log(parameter)
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webMarketSaleFavList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },

    // 出售方式
    saleFormat:function(row,column){
        if(row.sale_type == 1){
            return '许可'
        }else if(row.sale_type == 2){
            return '转让'
        }else{
            return '未知'
        }
    },
    // 授权状态
    authFormat:function(row,column){
        if(row.auth_status == 1){
            return '已下证'
        }else if(row.auth_status == 2){
            return '未下证'
        }else{
            return '未知'
        }
    },
    // 导出excel
    exportCheck() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
      }
       this.$confirm('确定导出勾选的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr)
          console.log(idStr)
          // 请求接口
          const checkParam = {ids:idStr}
            webExportCheckCollection(checkParam)
            .then(res => {
              this.loading = false
              console.log(res);
              res = checkLogin(res);
              if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: '导出成功!'
                  })
              location.href = res.data.url
              } else {
                this.$message({
                    type: 'info',
                    message: res.msg
                  })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('登陆已过期,请重新登陆!')
            })
          
       })
       .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    })
      .then(() => {
        const parameter = this.formInline
      webExportAllCollection(parameter)
            .then(res => {
              this.loading = false
              console.log(res);
              res = checkLogin(res);
              if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: '导出成功!'
                  })
              location.href = res.data.url
              } else {
                this.$message({
                    type: 'info',
                    message: res.msg
                  })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('登陆已过期,请重新登陆!')
            })

        })
    .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消导出'
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'addForm'){
        this.addFormVisible = false
      }else if(formName == 'verifyForm'){
        this.verifyFormVisible = false
      }else if(formName == 'editForm'){
        this.editFormVisible = false
      }else if(formName == 'cateForm'){
        this.cateFormVisible = false
      }else if(formName == 'cateCheck'){
        this.cateCheckVisible = false
      }else if(formName == 'verifyCheck'){
        this.verifyCheckVisible = false
      }else{
        return false
      }
      this.$refs[formName].resetFields()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/Collection.vue